import React, { useEffect } from 'react'
import { useModalBox, useOnChangeDetect } from '../../../../contexts'
import Button from '../../../button'
import Textarea from '../../../textarea'
import { FormStyled, Row } from './style'
import { ServiceModelDto } from '../../../../../domain/models'
import { changeDemand } from '../../../../../main/usecases'
import { useAlert } from 'react-alert'
import { useForm } from '../../../../hooks'
type FormModel = {
  service?: ServiceModelDto | null | undefined
  setSelectService: (e: any) => void
}

const ObjetiveForm = ({ service, setSelectService }: FormModel) => {
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const demandasInput = useForm()
  const { setRefresh } = useOnChangeDetect()

  useEffect(() => {
    if (service) {
      demandasInput.setValue(service.demandaObjetivo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [service])

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    if (service?.cdServico) {
      changeDemand(service?.cdServico).update({
        demandaObjetivo: demandasInput?.value
      })
      alert.show('Demandas e objetivos atualizados com sucesso.', {
        type: 'success',
        timeout: 4000
      })
      setSelectService((prev: ServiceModelDto) => ({
        ...prev,
        demandaObjetivo: demandasInput?.value
      }))
      setRefresh((prev: any) => !prev)
      modalClose()
    }
  }

  return (
    <FormStyled className="validate-report-modal" onSubmit={onSubmit}>
      <div>
        <Row className="d-flex">
          <Textarea
            label="Demandas e objetivos*"
            labelColor="#4F4F4F"
            name="resume"
            placeholder="Text"
            required
            {...demandasInput}
          />
        </Row>
      </div>
      <Row className="button-container">
        <label className="required-msg">*Campos obrigatórios</label>
        <div className="buttons">
          <button
            className="access-complete-register-button"
            onClick={() => modalClose(true)}
          >
            Cancelar
          </button>
          <Button>Salvar</Button>
        </div>
      </Row>
    </FormStyled>
  )
}

export default ObjetiveForm
